import { render, staticRenderFns } from "./EmployeesChart.vue?vue&type=template&id=2280b3ef&"
import script from "./EmployeesChart.vue?vue&type=script&lang=js&"
export * from "./EmployeesChart.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports